import { UserProfileRole } from '@@types/api.types';

export type AuthenticatedUserSessionState = {
  impersonation?: object | null;
  role?: UserProfileRole | null;
};

export function shouldRedirectAuthenticatedUserToAdmin(user: AuthenticatedUserSessionState | undefined): boolean {
  if (!user) {
    return false;
  }

  const isAdmin = user.role === UserProfileRole.ADMIN;

  return isAdmin && !user.impersonation;
}
